import types from './types';

// ログイン情報設定
export const doLogin = (loginInfo) => ({
  type: types.DO_LOGIN,
  loginInfo,
});

// ログアウト
export const doLogout = () => ({
  type: types.DO_LOGOUT,
});

// ユーザー情報取得
export const getUserInfo = (userInfo) => ({
  type: types.GET_USER_INFO,
  userInfo,
});

// ユーザー権限設定
export const setUserPerms = (userPerms) => ({
  type: types.SET_USER_PERMS,
  userPerms,
});

// ユーザー情報変更検出ハッシュ
export const setAuthorizedHash = (authorizedHash) => ({
  type: types.AUTHORIZED_HASH,
  authorizedHash,
});

export default {
  doLogin,
  doLogout,
  getUserInfo,
  setUserPerms,
  setAuthorizedHash,
};
